import { create } from 'zustand';

/** Whether the full-screen Launch Dashboard overlay is shown. */
interface LaunchDashboardState {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

/** Store for the Launch Dashboard overlay. */
export const useLaunchDashboardStore = create<LaunchDashboardState>((set) => ({
  open: false,
  toggle: () => set((state) => ({ open: !state.open })),
  close: () => set({ open: false }),
}));
